import { AccountType } from '@/Types/Enums/accountType';
import BusinessModel from '@/Models/businessModel';
import { LanguageDetails, LanguageDetailsSource } from '@/Types/languageDetails';
import { User } from '@/Types/user';

export default class UserModel {

  givenName: string;
  familyName: string;
  displayName: string;
  phoneNumber: string;
  emailAddress: string;
  accountType: AccountType;

  personaId: string;
  userId: string;
  agencyId: string;
  business: BusinessModel;
  languageDetails: LanguageDetails;
  updatedTimestamp: string;

  isBusinessAdminUser: boolean;
  selfResponseEnabled: boolean;

  registrationId: string;
  isFullyRegistered: boolean;
  canCompleteRegistration: boolean;

  constructor(serverModel: User) {
    this.givenName = serverModel.givenName;
    this.familyName = serverModel.familyName;
    this.displayName = serverModel.displayName;
    this.phoneNumber = serverModel.phoneNumber;
    this.emailAddress = serverModel.emailAddress;
    this.accountType = serverModel.business.accountType;

    this.personaId = serverModel.personaId;
    this.userId = serverModel.userId;
    this.agencyId = serverModel.agencyId;

    this.updatedTimestamp = serverModel.updatedTimestamp;

    this.isBusinessAdminUser = serverModel.isBusinessAdminUser;
    this.selfResponseEnabled = serverModel.selfResponseEnabled;

    /**
    * The registration ID for a user. Only set when a user is pre-registered and approved to register.
    */
    this.registrationId = serverModel.registrationId;
    this.isFullyRegistered = serverModel.isFullyRegistered;
    this.canCompleteRegistration = serverModel.canCompleteRegistration;

    this.business = new BusinessModel(serverModel.business);

    this.languageDetails = {
      languageCode: serverModel.languageCode,
      updatedDate: new Date(serverModel.updatedTimestamp),
      source: LanguageDetailsSource.UserDetails
    };
  }
}
